import styled from 'styled-components';

export const Link = styled.a.attrs(() => ({target: '_blank'}))`
    color: #2b2b2b;
`;
